import { render, staticRenderFns } from "./oftenFile.vue?vue&type=template&id=5c3af7c5"
import script from "./oftenFile.vue?vue&type=script&lang=js"
export * from "./oftenFile.vue?vue&type=script&lang=js"
import style0 from "./oftenFile.vue?vue&type=style&index=0&id=5c3af7c5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports